export const primaryFontFamily = "Roboto-Regular, sans-serif";
export const secondaryFontFamily = "Roboto-Medium, sans-serif";
export const primaryFontFamilyBold = "Roboto-Bold, sans-serif";

